import { formatMoney } from 'accounting'

import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faPlus, faWarning } from '@fortawesome/pro-light-svg-icons'

import { Button } from '@domain-group/suit-theme'

import NoticeBox from '@components/NoticeBox'

interface ContributionsRequiredNoticeProps {
  callbacks: {
    addContribution: VoidFunction,
  },
  contributionsDifference: number,
}

const ContributionsRequiredNotice = (props: ContributionsRequiredNoticeProps) => {
  const {
    callbacks: {
      addContribution,
    },
    contributionsDifference,
  } = props

  return (
    <NoticeBox
      footer={(
        <NoticeBox.Footer>
          <Button
            buttonStyle="secondaryUtility"
            icon={<FontAwesomeIcon icon={faPlus} />}
            onClick={addContribution}
            size="small"
            width="auto"
          >
            Add Contribution
          </Button>
        </NoticeBox.Footer>
      )}
      icon={<FontAwesomeIcon icon={faWarning} />}
    >
      <NoticeBox.Title>
        {`Contributions of ${formatMoney(contributionsDifference)} required for approval`}
      </NoticeBox.Title>
      <NoticeBox.Paragraph>
        The campaign requires additional contributions to cover the cost of this quote.
      </NoticeBox.Paragraph>
    </NoticeBox>
  )
}

export default ContributionsRequiredNotice
